<template>
  <ContractEditorCore
    ref="core"
    mode="addendum"
    :non-editable-component="nonEditableComponent"
    :editor-component="editorComponent"
    :show-start-date="false"
    :show-payment-validation="false"
    :fetch-params="{ get_addendums: true }"
    :on-contract-loaded="onContractLoaded"
    :parent-contract-id-getter="parentContractIdGetter"
    :responsable-from-state="'addendum'"
    :document-label="'Anexo'"
    @start-delete-contract="handleDeleteAddendum"
  />
</template>

<script>
import ContractEditorCore from './ContractEditorCore.vue'
import NonEditableContract from './NonEditableContract.vue'
import TextEditor from '@/components/Helpers/Editor/TextEditor'
import { deleteContractAddendum } from '@/helpers/api/contracts'

export default {
  name: 'ContractAddendumDetail',
  components: { ContractEditorCore },
  data() {
    return {
      nonEditableComponent: NonEditableContract,
      editorComponent:      TextEditor,
    }
  },
  methods: {
    // Guarda en el core los addendums hermanos del contrato padre
    onContractLoaded(response) {
      if (this.$refs.core) {
        this.$refs.core.otherContractAddendums = response.parent_contract_addendums ?? null
      }
    },

    // El contrato padre del anexo
    parentContractIdGetter(contract) {
      return contract?.addendum_to_contract_id
    },

    async handleDeleteAddendum() {
      const confirmed = await confirm('Eso eliminará también la Tabla de Costo Asociada. ¿Estás seguro de que deseas eliminar este anexo?')
      if (!confirmed) return
      const core     = this.$refs.core
      const contract = core?.contract
      if (!contract) return

      const result = await deleteContractAddendum({ contract_addendum_id: contract.id })
      if (result.code === 200) {
        this.$router.push({ name: 'ContractDetail', query: { id: contract.addendum_to_contract_id } })
        core.setMessage({ message: 'Se ha eliminado correctamente el anexo y su tabla de costo.', title: 'Anexo Eliminado', type: 'success', icon: 'mdi-check-circle', color: '#3EBFA3' })
      } else {
        core.setMessage({ message: 'Hubo un error en la operación, por favor intenta nuevamente', title: 'Ha ocurrido un error', type: 'danger', icon: 'mdi-close-octagon', color: '#FF1209' })
      }
    },
  },
}
</script>